export { CarTypeBannerMobile } from './CarTypeBanner';
